export const prepositions = [
  {
    id: 'prep-akk-list',
    category: 'prepositions',
    level: 'A2',
    title: 'Akkusativ Präpositionen (Parafjalët me Akuzativ)',
    detailedContent: `
      <section>
        <p>Këto parafjalë kërkojnë që gjithëçka që vjen direkt pas tyre të lakohet me forcë thelbësore vetëm në <b>Akkusativ</b>. Mjafton t'i mësoni përmendësh dhe nuk do të gaboni kurrë.</p>

        <h3>1. Memorizimi "D-U-F-E-O-G" / "B-I-S-D-U-R-C-H-F-Ü-R-G-E-G-E-N-O-H-N-E-U-M"</h3>
        <ul>
          <li><b>durch</b> (përmes / nëpërmjet): Për lëvizje fizike përmes një hapsire ose mjeti. <i>Wir gehen <b>durch den Park</b>. (den = Akkusativ)</i></li>
          <li><b>für</b> (për): Përcakton destinacionin, dobinë ose qëllimin. <i>Das Geschenk ist <b>für dich</b>.</i></li>
          <li><b>gegen</b> (kundër / rreth-për oraret): Tregon kundërshtim fizik / ideor ose një orar të përafërt. <i>Das Auto fährt <b>gegen den Baum</b>. (Kundër/drejt pemës). Wir treffen uns <b>gegen 20 Uhr</b> (Rreth orës 20).</i></li>
          <li><b>ohne</b> (pa): <i>Ich trinke Kaffee <b>ohne Zucker</b>.</i> (Pa sheqer - Zucker mbetet Akkusativ maskulin zero-artikel).</li>
          <li><b>um</b> (rreth hapësirës / në orën ekzakte): <i>Wir sitzen <b>um den Tisch</b>. Der Zug fährt <b>um 8 Uhr</b> ab.</i></li>
          <li><b>bis</b> (deri): Shpesh shoqërohet me një kohë ose stinë pa nyje. <i>Bis nächsten Monat! (Deri në muajin e ardhshëm - Akkusativ i pastër).</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Er läuft durch den Wald.', alb: 'Ai vrapon përmes pyllit. (Pylli "der Wald" bëhet "den Wald").' },
      { ger: 'Ich bin absolut gegen diesen Vorschlag.', alb: 'Jam absolutisht kundër këtij propozimi!' }
    ],
    exercises: []
  },
  {
    id: 'prep-dat-list',
    category: 'prepositions',
    level: 'A2',
    title: 'Dativ Präpositionen (Parafjalët e Dativit)',
    detailedContent: `
      <section>
        <p>Posa të përmendni, shkruani apo flisni njërën prej këtyre parafjalëve, fjalët që vijnë mas duhet të zbresin menjëherë në Rregullat e rastit <b>Dativ</b>, sido të jetë konteksti, qoftë lëvizje qoftë qetësi fizike!</p>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Ritmi memorizues:</strong> <i>"aus, außer, bei, mit, nach, seit, von, zu!"</i> Këto kërkojn gjithmonë DATIV!
        </div>

        <h3>Lista dhe Kuptimet:</h3>
        <ul>
          <li><b>aus</b> (nga vend origjine / jashtë tij): <i>Er kommt <b>aus der Türkei</b>. Sie geht <b>aus dem Haus</b>.</i></li>
          <li><b>außer</b> (përveç): <i>Alle waren da <b>außer meinem Bruder</b>.</i></li>
          <li><b>bei</b> (te / pranë dikujt / te ndërmarrja): <i>Ich arbeite <b>bei der Post</b>. Ich wohne <b>bei meinen Eltern</b>.</i><br/> Shkurtime: bei dem = <b>beim</b>.</li>
          <li><b>mit</b> (me / me mjet shkembimi/udhëtimi): <i>Ich fahre <b>mit dem Bus</b>. Ich gehe <b>mit dir</b>.</i></li>
          <li><b>nach</b> (drejt, mbas kohes, sipas): <i>Wir fahren <b>nach Berlin</b>. Gleich <b>nach der Arbeit</b> gehe ich schlafen.</i></li>
          <li><b>seit</b> (që nga - për theksimin e kohës vazhduese): <i><b>Seit einem Jahr</b> lerne ich Deutsch.</i></li>
          <li><b>von</b> (nga një pikënisje / rasti pronësor i pafjalorizuar): <i>Die E-Mail ist <b>von meinem Chef</b>.</i> <br/>Shkurtime: von dem = <b>vom</b>.</li>
          <li><b>zu</b> (te/drejt njerëzve, dyqaneve, fëstave): <i>Ich gehe <b>zum Arzt</b> (zu + dem). Wir fahren <b>zur Party</b> (zu + der).</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Ich bleibe heute bei meiner Familie.', alb: 'Sot do të jem te familja ime. ("bei" + feminin Dativ = "meiner").' },
      { ger: 'Trinkst du Kaffee mit oder ohne Milch?', alb: 'E pi kafen me ("mit" - dativ) apo pa ("ohne" - akkusativ) qumësht?' }
    ],
    exercises: [
      { question: 'Me cfarë rasti përdoret parafjala "mit"?', options: ['Akkusativ', 'Dativ', 'Genitiv'], correct: 1, explanation: 'Parafjala "mit" kërkon vazhdimisht Dativ, si "mit mir, mit dem Auto".' }
    ]
  },
  {
    id: 'prep-gen-list',
    category: 'prepositions',
    level: 'B2',
    title: 'Genitiv Präpositionen (Parafjalët e Genitivit)',
    detailedContent: `
      <section>
        <p>Parafjalët ekskluzivisht për nivele formale B1+ e lart. Ato gëlltisin një <b>Genitiv</b> dhe u japin një status tejet letrar e zyrtar fjalive tona. Ato duhet domosdoshmërisht të mbërrijnë në Genitiv, me gjithë atë -s-in tipik të mashkullorve/asnjsnësve në fund.</p>
        
        <h3>Më kryesoret:</h3>
        <ul>
          <li><b>wegen</b> (për shkak të, për arsyen e): <i>Wir können <b>wegen des Regens</b> nicht spielen.</i></li>
          <li><b>während</b> (gjatë): Tregon një thelb kohor rrethanor bashkohor. <i><b>Während des Unterrichts</b> darf man nicht essen. (Gjatë mësmit...).</i></li>
          <li><b>trotz</b> (pavarësisht thelbit / rrethanave të kundërta): <i><b>Trotz des Unfalls</b> kam er zur Arbeit. (Pavarësosh aksidentit, erdhi në punë).</i></li>
          <li><b>statt / anstatt</b> (në vend të): <i><b>Statt eines Tisches</b> kauften wir Stühle.</i></li>
        </ul>
        <p class="mt-4 italic text-gray-500">Këshillë: Edhe gjermanët vetë hasin vështirsi per t'ia bashku Genitivin në të folur. Gjithandej në jetën thelbësore (Në supermarket, rrugë) ata mund të thonë "wegen dem Regen" (me Dativ), POR në rregull shkollor mbetet URGJENT Genitiv.</p>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'wechselpraepositionen',
    category: 'prepositions',
    level: 'B1',
    title: 'Wechselpräpositionen (Parafjalët me dy fytyra / Dy drejtime)',
    detailedContent: `
      <section>
        <p>Ju prezantojmë magjinë thelbësore të Gjermanishtes: Ekzistojnë 9 parafjalë që ndryshojnë Thelbin gramatikor krejtësisht në varësi të SITUATËS FIZIKE të veprimit.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Të 9-ta:</strong> <b>in</b> (në/brenda), <b>an</b> (pranë - ngjitur tuc), <b>auf</b> (mbi - kontakt lart), <b>über</b> (mbi - ajrosur rreshqitësh pa kontakt), <b>unter</b> (nën), <b>vor</b> (përpara), <b>hinter</b> (mbrapa), <b>neben</b> (ngjitur anash me pak thelb hapsirë), <b>zwischen</b> (ndërmjet).
        </div>

        <h3>Rregulli Kyç i Mbartjes</h3>
        <h4>1. Pyetja Wohin? (Për Ku?) = AKKUSATIV</h4>
        <p>Nëse fjalia Thekson një Lëvizje Drejtimi, një kalim Fizik të Subjektit nga një Pozicion A drejt B-së, ne i vendosim Fjalët pas tyre në Akkusativ!</p>
        <ul>
          <li><i>Ich stelle das Glas <b>auf den Tisch</b>.</i> (Unë po e vë gotën -aksion thelb- mbi tavolinë = auf + Akkusativ).</li>
          <li><i>Wir fahren <b>in die Stadt</b>.</i> (Ne gajsim-hysim drejt qytetit = in + Akk).</li>
        </ul>

        <h4>2. Pyetja Wo? (Ku?) = DATIV</h4>
        <p>Nëse veprimi mbaroi. Objekti po RRI palëvizur, Po ndodhemi në kthesa rrethanore ku skemi lëvizje fizike ndryshimi A->B.</p>
        <ul>
          <li><i>Das Glas steht <b>auf dem Tisch</b>.</i> (Gota Qëndron ngrirës mbi Tavolin. S'ka lëvizje = auf + Dativ).</li>
          <li><i>Wir sind <b>in der Stadt</b>.</i> (Negjendemi fizikisht në qytet tani = in + Dativ).</li>
        </ul>
      </section>
    `,
    tables: [
      {
        label: 'Shkurtimet më thelbësore të Parafjalëve+',
        headers: ['Parafjala', '+ das (Akk) =', '+ dem (Dat) ='],
        rows: [
          ['in', 'ins (in das Haus)', 'im (im Haus)'],
          ['an', 'ans (ans Meer)', 'am (am Meer)']
        ]
      }
    ],
    examples: [
      { ger: 'Ich hänge das Bild an die Wand.', alb: 'Fizikisht po e lëvizi: Unë VAAR pikturen në (përmbi+kontakt) Mur! -> an + AKKUSATIV (Wand = die. die mbetet die)' },
      { ger: 'Das Bild hängt an der Wand.', alb: 'Asnjë aksion levizje, thelb pasive: Muri Qëndron I VARUR tek Muri. -> an + Dativ! (die bëhet der Wand)' }
    ],
    exercises: [
      { question: 'Plotësoni fjalinë: "Das Baby schläft ___ (in) Bett" ("das Bett")', options: ['ins', 'in', 'im'], correct: 2, explanation: 'Gjumi është aksion THELB pasiv vendndodhtje ("Wo?"). Prandaj kërkohet dativi. in + dem Bett shkurtohet në IM Bett.' },
      { question: 'Si themi: "Unë po shkoj në/drejt kinema"? (das Kino)', options: ['Ich gehe in das Kino / ins Kino', 'Ich gehe im Kino', 'Ich gehe zu der Kino'], correct: 0, explanation: 'Folja lëvizëse e thellë "gehen" (Wohin?) të drejtojnë nga A në B thelbësisht -> Akkusativ. "in das" = ins.' }
    ]
  }
];
